import { graphql, useStaticQuery } from 'gatsby'

const useSiteMetadata = (): { title: string; description: string; siteUrl: string; image: string } => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
          image
        }
      }
    }
  `)

  return data.site.siteMetadata
}

export default useSiteMetadata
